import { render, staticRenderFns } from "./CellTag.vue?vue&type=template&id=4d6f74e3&scoped=true&lang=pug&"
import script from "./CellTag.vue?vue&type=script&lang=js&"
export * from "./CellTag.vue?vue&type=script&lang=js&"
import style0 from "./CellTag.vue?vue&type=style&index=0&id=4d6f74e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f74e3",
  null
  
)

export default component.exports